(() => {
  if (window.__tathagatServicesMotionBooted) return;
  window.__tathagatServicesMotionBooted = true;

  const initialize = (root) => {
    if (!root || root.dataset.servicesInitialized === 'true') return;
    root.dataset.servicesInitialized = 'true';

    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const services = root.querySelectorAll('[data-service-card]');
    let frame = 0;
    let observer;

    if (!reduceMotion && 'IntersectionObserver' in window) {
      root.classList.add('services-motion-enabled');
      observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        }
      });
      }, { threshold: 0.18 });
      services.forEach((service) => observer.observe(service));
    }

    services.forEach((service) => {
    const art = service.querySelector('[data-service-art]');
    if (!art || reduceMotion) return;
    service.addEventListener('pointermove', (event) => {
      const bounds = art.getBoundingClientRect();
      const x = (event.clientX - bounds.left) / bounds.width - 0.5;
      const y = (event.clientY - bounds.top) / bounds.height - 0.5;
      art.style.setProperty('--services-art-x', x);
      art.style.setProperty('--services-art-y', y);
    });
    service.addEventListener('pointerleave', () => {
      art.style.setProperty('--services-art-x', '0');
      art.style.setProperty('--services-art-y', '0');
    });
    });

    const updateScrollState = () => {
    frame = 0;
    const viewport = window.innerHeight;
    let tint = '#FAFAF7';
    services.forEach((service) => {
      const bounds = service.getBoundingClientRect();
      if (bounds.top < viewport * 0.5 && bounds.bottom > viewport * 0.5) {
        tint = service.dataset.color || tint;
      }
      if (!reduceMotion && bounds.bottom > -viewport && bounds.top < viewport * 2) {
        const art = service.querySelector('[data-service-art]');
        if (art) {
          const progress = Math.max(-1, Math.min(1, (bounds.top + bounds.height / 2 - viewport / 2) / viewport));
          art.style.setProperty('--services-art-scroll', String(-progress * 0.55));
        }
      }
    });
    root.style.setProperty('--services-tint', tint);
    };

    const requestScrollState = () => {
    if (!frame) frame = window.requestAnimationFrame(updateScrollState);
    };
    updateScrollState();
    window.addEventListener('scroll', requestScrollState, { passive: true });
    window.addEventListener('resize', requestScrollState);
    const cleanup = (event) => {
      if (event.target === root.closest('.shopify-section')) {
        if (frame) window.cancelAnimationFrame(frame);
        observer?.disconnect();
        root.classList.remove('services-motion-enabled');
        root.dataset.servicesInitialized = 'false';
        window.removeEventListener('scroll', requestScrollState);
        window.removeEventListener('resize', requestScrollState);
        window.removeEventListener('shopify:section:unload', cleanup);
      }
    };
    window.addEventListener('shopify:section:unload', cleanup);
  };

  const boot = () => initialize(document.querySelector('[data-services-page]'));
  boot();
  document.addEventListener('shopify:section:load', boot);
})();
